<!-- 产品中心 -->
<template>
    <div>
      <sub-banner id="id_about">
        <img src="../../assets/images/news/news_banner.jpg"/>
      </sub-banner>
       <!-- <div class="news_company">
          <div class="product_contents">
              <div class="product_line_left"></div>
              <div class="product_title">公司资讯</div>
              <div class="product_line_right"></div>
          </div>
          <div class="news_content">
                <div class="news_img">
                  <img src="../../assets/images/news/news_company_one.png" />
                </div>
                <div class="news_content_info">
                <div class="news_item">
                    <div class="date_info">
                    <div class="date_date">08/29</div>
                    <div class="date_year">2021</div>
                    </div>
                    <div class="news_abstract">
                    <div class="abstract_title">工业设计</div>
                    <div class="abstract_info">
                        11月10日，在2017年中山全国结直肠癌多学科（MDT）诊疗学习班上，
                        “上海结直肠肿瘤微创工程技术研究中心”正式宣告成立...
                    </div>
                    </div>
                </div>

                
                <div class="news_item">
                    <div class="date_info">
                    <div class="date_date">08/29</div>
                    <div class="date_year">2021</div>
                    </div>
                    <div class="news_abstract">
                    <div class="abstract_title">工业设计</div>
                    <div class="abstract_info">
                        11月10日，在2017年中山全国结直肠癌多学科（MDT）诊疗学习班上，
                        “上海结直肠肿瘤微创工程技术研究中心”正式宣告成立...
                    </div>
                    </div>
                </div>

                
                <div class="news_item">
                    <div class="date_info">
                    <div class="date_date">08/29</div>
                    <div class="date_year">2021</div>
                    </div>
                    <div class="news_abstract">
                    <div class="abstract_title">工业设计</div>
                    <div class="abstract_info">
                        11月10日，在2017年中山全国结直肠癌多学科（MDT）诊疗学习班上，
                        “上海结直肠肿瘤微创工程技术研究中心”正式宣告成立...
                    </div>
                    </div>
                </div>

                
                <div class="news_item">
                    <div class="date_info">
                    <div class="date_date">08/29</div>
                    <div class="date_year">2021</div>
                    </div>
                    <div class="news_abstract">
                    <div class="abstract_title">工业设计</div>
                    <div class="abstract_info">
                        11月10日，在2017年中山全国结直肠癌多学科（MDT）诊疗学习班上，
                        “上海结直肠肿瘤微创工程技术研究中心”正式宣告成立...
                    </div>
                    </div>
                </div>
                </div>
          </div>
          <div class="more_s more_s_top">
             <div class="more_c">
                <div class="more_btn">{{$t('indexText.more')}}</div>
             </div>
           </div>
       </div> -->

         <!--新闻资讯-->
      <div class="news_real_time" v-if="companyData.length>0">
        <div class="news_info news_info_special">
           <div class="product_contents">
              <div class="product_line_left"></div>
              <div class="product_title">{{$t('NavabarText.company_news')}}</div>
              <div class="product_line_right"></div>
          </div>
            <div class="news_info_content">
              <div class="dynamics_detail rightturnleft_one">
                  <div class="dynamics_item" v-for="item in companyData" :key="item.id" @click="watchDetail(item)">
                      <div class="dynamics_date">
                          <div class="day">{{item.date}}</div>
                          <div class="date">{{item.year}}/{{item.month}}</div>
                      </div>
                      <div class="dynamics_item_content">
                          <div class="dynamic_title">{{item.title}} </div>
                          <div class="dynamic_content_desc">
                            {{item.articleAbstract}}
                          </div>
                      </div>
                  </div>
                  <div class="more_s">
                        <div class="more_c">
                            <div class="more_btn" @click="moreClick('company_news')" v-show="showCompanyData">{{$t('indexText.more')}}</div>
                        </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
      <!--新闻资讯-->

       <div class="industry_dynamics_info">
           <div class="product_contents">
              <div class="product_line_left"></div>
              <div class="product_title">{{$t('NavabarText.navbr_child_news_2')}}</div>
              <div class="product_line_right"></div>
          </div>
          <div class="dynamics_content">
              <div class="dynamics_detail two_transfer">
                  <div class="dynamics_item" v-for="item in industryData" :key="item.id" @click="watchDetail(item)">
                      <div class="dynamics_date">
                          <div class="day">{{item.date}}</div>
                          <div class="date">{{item.year}}/{{item.month}}</div>
                      </div>
                      <div class="dynamics_item_content">
                          <div class="dynamic_title">{{item.title}} </div>
                          <div class="dynamic_content_desc">
                            {{item.articleAbstract}}
                          </div>
                      </div>
                  </div>
                  <div class="more_s">
                        <div class="more_c">
                            <div class="more_btn" @click="moreClick('industry_news')" v-show="showIndustryDataData">{{$t('indexText.more')}}</div>
                        </div>
                  </div>
              </div>
          </div>
       </div>
    
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'
import {getArticleByTypeList} from '../../service/service'
import SubBanner from "@/components/sub-banner";
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-新闻资讯',
      metaName:'广州市熵达贸易有限公司-新闻资讯',
      metaContent:'广州市熵达贸易有限公司-新闻资讯',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' ,  
      companyCode:'company_news',//公司资讯
      companyId:0,//公司资讯Id
      industryCode:'industry_news',//行业动态Code
      industryId:0,//行业动态Id
      companyData:[],//公司资讯Data
      industryData:[],//行业动态Data
      showCompanyData:true,
      showIndustryDataData:true,
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]

    },
    'companyId':function(nval,oval){
      if(nval!=0){
        this.getArticleByCompanyeList(1,4);
      }
    },
    'industryId':function(nval,oval){
      if(nval!=0){
        this.getArticleByIndustryList(1,4);
      }
    },
  },
  methods: {
    watchDetail(item){
        this.$router.push({
            path: '/article?id='+item.id
        });
      },
    moreClick(val){
      if(val=='company_news'){
        this.getArticleByCompanyeList(1,9999);
      }else if(val=='industry_news'){
        this.getArticleByIndustryList(1,999);
      }
    },
    async getArticleByCompanyeList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.companyId,pageNum,pageSize);
       if(resp&&resp.data){
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1;
           v.date=dateN.getDate();
         })
         this.companyData=resp.data;
         if(this.companyData.length==resp.total){
           this.showCompanyData=false;
         }else{
           this.showCompanyData=true;
         }
       }
    },
    async getArticleByIndustryList(pageNum,pageSize){
       let resp=await getArticleByTypeList(this.industryId,pageNum,pageSize);
       if(resp&&resp.data){
         resp.data.map((v)=>{
           let dateN=new Date(v.effectiveTime)
           v.year=dateN.getFullYear();
           v.month=dateN.getMonth()+1;
           v.date=dateN.getDate();
         })
         this.industryData=resp.data;
         
         if(this.industryData.length==resp.total){
           this.showIndustryDataData=false;
         }else{
           this.showIndustryDataData=true;
         }
       }
     },
  },
  created () {

  },
  mounted () {
    if(this.$store.state.ArticleTypeData){
      let ArticleTypeData=this.$store.state.ArticleTypeData;
      ArticleTypeData.map((v)=>{
        if(v.code==this.companyCode){
          this.companyId=v.id
        }else if(v.code==this.industryCode){
          this.industryId=v.id;
        }
      });

    }
  },
}
</script>
<style lang='scss' scoped>

 @import '../../assets/css/animation.css';
.news_info_special{
    padding-top:0px !important;
}
.news_real_time{
      width:100%;
      background-color: #f8f8f8;
      .news_info{
        width:70%;
        margin:auto;
         padding-top:100px;
          padding-bottom:121px;
        .news_real_time_title{
            font-size: 40px;
            font-weight: bold;
            color: #4f7cbd;
            padding-bottom:30px;
        }
        .news_content{
          display: flex;
          justify-content: center;
          align-items: center;
          // flex-wrap: wrap;
          flex-direction: row;
         
          .news_img{
            width:488px;
            margin-bottom:20px;
            img{
              width:100%;
              height: 100%;
            }
          }
          .news_content_info{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            margin-left:50px;
            .news_item{            
              margin-bottom:40px;  
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: row;
              position: relative;
              .date_info{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                cursor: pointer;
                .date_date{
                  font-size:30px;
                  font-weight: bold;

                }
                .date_year{
                  font-size:16px;
                  color:#333333;
                }
              }
              .news_abstract{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                margin-left:37px;
                width:493px;
                cursor: pointer;
                .abstract_title{
                  font-size:20px;
                  // font-weight: bold;
                  color:#333333;
                  text-align: left;
                }
                .abstract_info{
                  font-size:18px;
                  color:#999999;
                  line-height: 30px;
                  padding-top:11px;
                  text-align: left;
                }
              }
              
            }
            
            .news_item :after{
              content:" ";
              position:absolute;
              left:0;
              bottom:-10px;
              width:100%;
              height:1px;
              transform:scaleY(.5);
              background-color:#eeeeee;
              
            }
            .news_item {
              &:last-child :after{
                  height: 0px !important;
              }
            }


            
                      
          }
        }

        .news_info_content{
              // width:70%;
              // margin:auto;
              .dynamics_detail{
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
                  .dynamics_item{
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      margin-bottom:100px;
                      .dynamics_date{
                          padding:10px 20px;
                          background-color: #ffffff;
                        border-radius: 10px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex-direction: column;
                          cursor: pointer;
                          .day{
                              font-size:40px;
                              color:#333333;
                              font-weight: bold;
                          }
                          .date{
                              font-size:16px;
                              color:#333333;
                          }
                      }
                      .dynamics_item_content{
                          max-width:998px;
                          margin-left:30px;
                          display: flex;
                          align-items: flex-start;
                          justify-content: flex-start;
                          flex-direction: column;
                          cursor: pointer;
                          .dynamic_title{
                            color:#333333;
                            font-size:21px !important;
                            font-weight: bold;
                            margin-bottom:23px;
                          }
                          .dynamic_content_desc{
                              text-align: left;
                              color:#999999;
                              font-size: 18px;;
                          }
                      }
                      // &:last-child{
                      //     margin-bottom:0px  !important;
                      // }
                  }
              }
            }
      }
    }
    

.news_company{
    width:100%;
    background-color: #f8f8f8;
    padding-bottom:134px;
    .news_content{  
        width:70%;
        margin:auto;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        
       
        .news_img{
            width:488px;
            margin-bottom:20px;
            img{
              width:100%;
              height: 100%;
            }
        }
        .news_content_info{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            margin-left:50px;
            .news_item{            
              margin-bottom:40px;  
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-direction: row;
              position: relative;
              .date_info{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                cursor: pointer;
                .date_date{
                  font-size:30px;
                  font-weight: bold;

                }
                .date_year{
                  font-size:16px;
                  color:#333333;
                }
              }
              .news_abstract{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-direction: column;
                margin-left:20px;
                width:493px;
                cursor: pointer;
                .abstract_title{
                  font-size:20px;
                  // font-weight: bold;
                  color:#333333;
                }
                .abstract_info{
                  font-size:18px;
                  color:#999999;
                  line-height: 30px;
                  padding-top:11px;
                  text-align: left;
                }
              }
              
            }
            
            .news_item :after{
              content:" ";
              position:absolute;
              left:0;
              bottom:-10px;
              width:100%;
              height:1px;
              transform:scaleY(.5);
              background-color:#eeeeee;
              
            }
            .news_item {
              &:last-child :after{
                  height: 0px !important;
              }
            }
                      
        }
    }

}


.product_contents{
        width:70%;
        margin:auto;
        padding-top:115px;
        padding-bottom:52px;
        display: flex;
        align-items: center;
        justify-content: center;
}
.product_line_left{
    width: 210px;
    // height: 0.5px;
    background-color: #2e2d32;
    border: solid 1px #4f7cbd;
    margin-right:28px;
}
.product_title{
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #4f7cbd;
}
.product_line_right{
    width: 210px;
    // height: 1px;
    background-color: #2e2d32;
    border: solid 1px #4f7cbd;
    margin-left:28px;
}

.more_s_top{
    margin-top:90px;
}
.more_s{
    width: 100%;
    text-align: center;
    .more_c{
        display: flex;
        justify-content: center;
        cursor: pointer;
        .more_btn{
            width: 147px;
            height: 49px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 25px;
            border: solid 2px #4f7cbd;
            color:#2750a2;
            font-size:20px;
            letter-spacing: 2px;
        }
        .more_btn:hover{
            background-color: #4f7cbd !important;
            color:#ffffff !important;
        }
    }
}


 .industry_dynamics_info{
     background-color:#ffffff;
     padding-bottom:100px ;
     .dynamics_content{
         width:70%;
         margin:auto;
         .dynamics_detail{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .dynamics_item{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom:100px;
                .dynamics_date{
                    padding:10px 12px;
                    background-color: #f8f8f8;
	                border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    cursor: pointer;
                    .day{
                        font-size:40px;
                        color:#333333;
                        font-weight: bold;
                    }
                    .date{
                        font-size:16px;
                        color:#333333;
                    }
                }
                .dynamics_item_content{
                    max-width:998px;
                    margin-left:30px;
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    flex-direction: column;
                    cursor: pointer;
                    .dynamic_title{
                      color:#333333;
                      font-size:22px;
                      font-weight: bold;
                      margin-bottom:23px;
                    }
                    .dynamic_content_desc{
                        text-align: left;
                        color:#999999;
                        font-size: 18px;;
                    }
                }
                // &:last-child{
                //     margin-bottom:0px  !important;
                // }
            }
         }
     }
 }
</style>




// WEBPACK FOOTER //
// src/view/news/index.vue